import React from "react";
import ReactDOM from "react-dom";
import { AiFillCloseCircle } from "react-icons/ai";
import { useDispatch } from "react-redux";
// import CreateProductModal from "./CreateProductModal";
const ViewRequestModal = ({ open, data }) => {
  const dispatch = useDispatch();

  if (!open) return null;
  return ReactDOM.createPortal(
    <div className="modal-container">
      <div className="modal-inventory">
        <button
          className="add_btn"
          onClick={() =>
            dispatch({ type: "VIEW_CLOSE_REQUEST_MODAL", payload: false })
          }
        >
          <AiFillCloseCircle />
        </button>
        <fieldset>
          <legend>Request</legend>
          {data.map((data) => {
            const { name, total, price, _id } = data;
            return (
              <div key={_id}>
                {name} x {total} = {price}
              </div>
            );
          })}
        </fieldset>
      </div>
    </div>,
    document.getElementById("modal")
  );
};

export default ViewRequestModal;
